export const GET_COUNTRIES = "GET_COUNTRIES"
export const ORDER_COUNTRIES = "ORDER_COUNTRIES"

export const GET_ACTIVITIES = "GET_ACTIVITIES"
export const CREATE_ACTIVITY = "CREATE_ACTIVITY"

export const GET_COUNTRY_DETAIL = "GET_COUNTRY_DETAIL"

export const FILTER_BY_CONTINENT = "FILTER_BY_CONTINENT"


export const ALPHA_ASC = "ALPHA_ASC"
export const ALPHA_DESC = "ALPHA_DESC"
export const POP_ASC = "POP_ASC"
export const POP_DESC = "POP_DESC"